import { render, staticRenderFns } from "./modal_detallesEmpresa.vue?vue&type=template&id=ba4a1570&lang=true&"
import script from "./modal_detallesEmpresa.vue?vue&type=script&lang=js&"
export * from "./modal_detallesEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports